import { configureStore } from '@reduxjs/toolkit';
import humidityZone from './humidityZone/humidityZoneSlice.js';
import humidityRoom from './humidityRoom/humidityRoomSlice.js';
import wallsCharacteristics from './WallsCharacteristics/WallsCharacteristicsSlice.js';
import brand from './brand/brandSlice.js';

export default configureStore({
  reducer: {
    humidityZone,
    humidityRoom,
    wallsCharacteristics,
    brand
  },
});